export type ProjectRouteView = 'cockpit' | 'table' | 'plan-2d' | 'layers-3d' | 'pov-3d' | 'presentation' | 'route-editor' | 'differences'
export type ReferenceRouteView = 'overview' | 'plan-2d' | 'layers-3d' | 'pov-3d' | 'presentation' | 'editor'

export type AppRoute =
  | { kind: 'portfolio' }
  | { kind: 'project'; projectCode: string; view: ProjectRouteView }
  | { kind: 'reference'; view: ReferenceRouteView }

const PROJECT_VIEWS = new Set<ProjectRouteView>(['cockpit', 'table', 'plan-2d', 'layers-3d', 'pov-3d', 'presentation', 'route-editor', 'differences'])
const REFERENCE_VIEWS = new Set<ReferenceRouteView>(['overview', 'plan-2d', 'layers-3d', 'pov-3d', 'presentation', 'editor'])

export function parseRoute(pathname = window.location.pathname): AppRoute {
  const parts = pathname.split('/').filter(Boolean).map(decodeURIComponent)
  if (!parts.length) return { kind: 'portfolio' }
  if (parts[0] === 'reference' && REFERENCE_VIEWS.has(parts[1] as ReferenceRouteView)) {
    return { kind: 'reference', view: parts[1] as ReferenceRouteView }
  }
  if (parts[0] === 'projects' && parts[1] && PROJECT_VIEWS.has(parts[2] as ProjectRouteView)) {
    return { kind: 'project', projectCode: parts[1], view: parts[2] as ProjectRouteView }
  }
  return { kind: 'portfolio' }
}

export function routePath(route: AppRoute) {
  if (route.kind === 'portfolio') return '/'
  if (route.kind === 'reference') return `/reference/${route.view}`
  return `/projects/${encodeURIComponent(route.projectCode)}/${route.view}`
}
